/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { CoverageTypeEnum } from "../enum/coverage-type.enum";
import { DamageTypeEnum } from "../enum/damage-type.enum";

/**
 * Maps a  @DamageTypeEnum to a @CoverageTypeEnum
 */
export const DamageTypeToCoverageTypeMap = new Map<DamageTypeEnum, CoverageTypeEnum>([
  [DamageTypeEnum.GLASS_DAMAGE, CoverageTypeEnum.PARTIALLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.MANEUVERING_DAMAGE, CoverageTypeEnum.FULLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.OPERATIONAL_DAMAGE, CoverageTypeEnum.FULLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.ONCOMING_TRAFFIC_DAMAGE, CoverageTypeEnum.MOTORISTS_THIRD_PARTY_LIABILITY_COVERAGE],
  [DamageTypeEnum.ANIMAL_DAMAGE, CoverageTypeEnum.PARTIALLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.MARTEN_DAMAGE, CoverageTypeEnum.PARTIALLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.HAIL_DAMAGE, CoverageTypeEnum.PARTIALLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.PARTS_THEFT_BREAK_IN, CoverageTypeEnum.PARTIALLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.TOTAL_THEFT, CoverageTypeEnum.PARTIALLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.TOTAL_LOSS, CoverageTypeEnum.FULLY_COMPREHENSIVE_COVERAGE],
  [DamageTypeEnum.BUSINESS_LIABILITY_COVERAGE_DAMAGE, CoverageTypeEnum.BUSINESS_LIABILITY_COVERAGE],
  [DamageTypeEnum.UNKNOWN, CoverageTypeEnum.OTHER],
  [DamageTypeEnum.OTHER, CoverageTypeEnum.OTHER]
]);
